// @flow strict

import { App as AntdApp, Button, Card, Progress, Spin } from 'antd';
import React, { useEffect, useState } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { getUpdatePaymentInfo } from '../../api/pricing';
import useRemaining from '../../Hooks/useRemaining';
import { calculatePercentage } from '../../Utility/utility';
import ActivePlan from './ActivePlan';
import CountdownTimer from './CountdownTimer';

function SubscriptionData() {
  const [updateLink, setUpdateLink] = useState(null);
  const { activePlan, remaining, expireDate, isLoading } = useRemaining();
  const [fetching, setFetching] = useState(false);

  const getUpdatePayLink = async () => {
    setFetching(true);

    try {
      const res = await getUpdatePaymentInfo();
      if (res?.data?.url) {
        setUpdateLink(res.data.url);
      }
    } catch (error) {
      console.log(error)
    } finally {
      setFetching(false);
    };
  };

  useEffect(() => {
    getUpdatePayLink();
  }, []);

  return (
    <Card title={<h4>Subscription</h4>}>
      {
        (isLoading || fetching) ?
          <Spin
            spinning={fetching || isLoading}
            tip="Loading..."
          >
            <div className="py-5"></div>
          </Spin> :
          <>
            <>
              <div>
                <p className="sub-title text-secondary">
                  You are currently on the monthly
                  <span className="text-info font-text-bold">
                    {` ${activePlan?.name} `}
                  </span>
                  subscription plan.
                </p>
              </div>

              <div className="remaining-progress">
                <div className="remaining-info">
                  <p className="my-1">Remaining Token</p>
                  <p className="my-1">{`${remaining?.token || 0}/${activePlan?.token || 0}`}</p>
                </div>
                <Progress
                  percent={calculatePercentage(activePlan?.token, remaining?.token)}
                  showInfo={false}
                  strokeColor={{
                    from: '#108ee9',
                    to: '#87d068',
                  }}
                />
              </div>
            </>

            <div className="my-4 d-flex flex-column align-items-center gap-3 justify-content-center">
              <CountdownTimer targetDate={expireDate} />
              {
                updateLink &&
                <Button className="text-decoration-none" href={updateLink} target="_blank" size="large" icon={<FaExternalLinkAlt />} type="primary">
                  Update Payment Info
                </Button>
              }
            </div>

            <div className="mt-5 d-flex justify-content-center">
              <AntdApp>
                <ActivePlan
                  activePlan={activePlan}
                  plan={activePlan}
                  remaining={remaining}
                />
              </AntdApp>
            </div>
          </>
      }
    </Card>
  );
};

export default SubscriptionData;